import { IGetState, TCardId } from '../../../../types/types';
import { Dispatch, ThunkAction } from '../../../../types/actions';
import { ICards } from '../../../../store/model/cards/types';
import { cardsUpdate } from '../../../../store/model/actionCreators/cardsUpdate';
import { deleteRest } from './api/deleteRest';
import { updateAction as cUpdateAction } from '../../../../view/react_components/main/chatView/store/chat/actions/updateAction';
import { chatDeleteAction } from '../../../../view/react_components/main/chatView/store/chatView/actions/chatDeleteAction';
import { getChat } from '../../../../view/react_components/main/chatView/store/chatView/selectors/getChat';
import { chatUpdateAction } from 'app/view/react_components/main/chatView/store/chatView/actions/chatUpdateAction';
import { TChatId } from 'app/types/rest/IRestChat';
import { getCard } from 'app/store/model/selectors/getCard';
import { sendAuthUserRealTimeStoreAction } from 'app/view/react_components/base/helpers/realTimeHelperTS';
import { setGroupOpenedChatId } from '../../../../view/react_components/main/chatView/helpers/setGroupOpenedChatId';

//TODO done
/***
 *  Отписываемся от чата карты
 * @param cardId
 * @param chatId
 */
export const chatCardDelete = (
    cardId: TCardId,
    chatId: TChatId
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        let chat = getChat(getState(),chatId);

        let cardsForRollback: ICards = {
            [cardId]: {
                chatId
            }
        };
        const cards: ICards = {
            [cardId]: {
                chatId: 0
            }
        };
        dispatch(cardsUpdate(cards));
        dispatch(sendAuthUserRealTimeStoreAction(cardsUpdate(cards)));

        return dispatch(deleteRest(chatId))
            .then(() => {
                if (chat) {
                    dispatch(chatDeleteAction(chat));
                    dispatch(sendAuthUserRealTimeStoreAction(chatDeleteAction(chat)));
                }
                setGroupOpenedChatId(chat.chatGroupId, null);
                return ;
            })
            .catch((e: any) => {
                console.error(e);
                dispatch(cardsUpdate(cardsForRollback));
                if (chat) {
                    dispatch(chatUpdateAction(chatId, cUpdateAction(chat)));
                }
            })
            .finally(() => {
            });
    };
    return action;
};
